import { TextField, Grid } from '@mui/material';
import { IPrompt } from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsTypoColors, WsButton } from 'wisestep-base';

export interface ICostomToolTioLayout {
  jdCountNumber: number;
  promptData: IPrompt[];
  onSetPromptdata: (value: IPrompt[]) => void;
  handelJDCountNumber: (value: number) => void;
  HandleTooltipOpen: (value: boolean) => void;
}

const CostomToolTioLayout = ({
  jdCountNumber,
  promptData,
  onSetPromptdata,
  handelJDCountNumber,
  HandleTooltipOpen,
}: ICostomToolTioLayout) => {
  const handleChangeJDCount = (event) => {
    handelJDCountNumber(event.target.value);
  };
  const onSaveJdCount = () => {
    const updatedPromptData = promptData.map((data) => {
      return { ...data, jdCount: jdCountNumber };
    });
    onSetPromptdata(updatedPromptData);
    HandleTooltipOpen(false);
  };
  return (
    <Grid container>
      <Grid
        item
        pt={0.1}
        display="flex"
        alignItems="center"
        sx={{
          marginLeft: 2.5,
          marginRight: 2.5,
          marginTop: 2.5,
        }}
      >
        <WsTypography
          variant={WsTypoVariants.TITLE}
          color={WsTypoColors.BLACK}
          cursor="pointer"
          bold={false}
        >
          Minimum No. Of Words for Job Description
        </WsTypography>
        <TextField
          type="number"
          value={jdCountNumber}
          onChange={handleChangeJDCount}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          sx={{ width: 110, marginLeft: 3.8 }}
          size="small"
          inputProps={{
            step: 1,
            min: 0,
          }}
        />
      </Grid>
      <Grid
        item
        pt={0.1}
        display="flex"
        alignItems="center"
        sx={{
          marginTop: 2.5,
          width: '70%',
          maxWidth: 500,
          marginLeft: 2.5,
          marginRight: 2.5,
        }}
      >
        <WsTypography
          variant={WsTypoVariants.TITLE}
          color={WsTypoColors.SECONDARY}
          cursor="pointer"
          bold={false}
        >
          Higher the count (Ideally 200-250 words), relevant the generated questions will be.
        </WsTypography>
      </Grid>
      <Grid
        container
        pt={0.1}
        display="flex"
        alignItems="flex-end"
        sx={{
          margin: 2.5,
          justifyContent: 'flex-end',
        }}
      >
        <WsButton size="large" variant="contained" onClick={onSaveJdCount}>
          Save
        </WsButton>
      </Grid>
    </Grid>
  );
};
export default CostomToolTioLayout;
